export default __webpack_public_path__ + "static/tablet-shine-047b1c21eef06f6171500b611a4769c5.webp";